export const SET_LOGOUT = 'SET_LOGOUT'